import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentTypeComponent } from './payment-type.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [PaymentTypeComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,

  ],
  exports: [PaymentTypeComponent],
  entryComponents: [PaymentTypeComponent],
})
export class PaymentTypeModule { }
